import React from 'react';
import './style.scss';
import imgURL from '../../lib/imgURL';

interface ChatTooltipProps {
  text: string;
  visible: boolean;
  position?: 'top' | 'bottom' | 'left' | 'right';
  onClose?: CallableFunction;
}

const ChatTooltip: React.FC<ChatTooltipProps> = ({ text, visible, position = 'top', onClose }) => {
  if (!visible) return null;

  return (
    <div className={`chat-tooltip chat-tooltip--${position}`}>
      <div className="chat-tooltip-content">
        <img className='chat-tooltip-content-icon' src={imgURL['guide-logo']} />
        {text}
        {onClose && <img onClick={() => onClose && onClose()} className='chat-tooltip-content-icon cursor-pointer' src={imgURL['cross-modal-dark']} />}
      </div>
      <div className="chat-tooltip-arrow" />
    </div>
  );
};

export default ChatTooltip;
